import React from "react";
import { Outlet } from "react-router-dom";

const WithoutNav = () => <Outlet />;

export default WithoutNav;
